<app-header-back-button
  class="back"
  [coreUserActivityClickTracking]="`Close ${pageName()}`"
/>

<div class="center">
  <ng-content select="[slot=center]"/>
</div>

<div class="right">
  <ng-content select="[slot=right]"/>
</div>
<!--<app-header-table-name-->
<!--  class="table-name"-->
<!--/>-->
